import React from 'react';
import './Avatar.css';

function initials(name = '') {
  return name
    .split(/[.\s_-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || '')
    .join('');
}

export default function Avatar({ url, name = '', size = 40 }) {
  const style = { width: size, height: size, fontSize: size * 0.38 };
  if (url) {
    return (
      <img
        className="ui-avatar ui-avatar--img"
        src={url}
        alt=""
        style={style}
      />
    );
  }
  return (
    <span className="ui-avatar" style={style} aria-hidden>
      {initials(name) || '?'}
    </span>
  );
}
